<admin-app-header></admin-app-header>
<app-enterprise-admin-bar></app-enterprise-admin-bar>

<div class="container-fluid admin-container">
    <!-- Page Header -->
    <div class="page-header">
        <h1>
            <i class="fa-solid fa-users"></i> Parkers
            <small class="text-muted" *ngIf="enterpriseContext.currentEnterprise"> - {{ enterpriseContext.currentEnterprise.name }} </small>
        </h1>
        <p class="text-muted">View parkers who have subscriptions in this enterprise</p>
    </div>

    <!-- No Enterprise Selected -->
    <div *ngIf="!enterpriseContext.currentEnterpriseKey" class="alert alert-info">
        <i class="fa-solid fa-info-circle"></i>
        Please select an enterprise from the menu above to view parkers.
    </div>

    <!-- Content when enterprise is selected -->
    <ng-container *ngIf="enterpriseContext.currentEnterpriseKey">
        <!-- Stats Cards -->
        <div class="stats-row">
            <div class="stat-card">
                <div class="stat-icon">
                    <i class="fa-solid fa-users"></i>
                </div>
                <div class="stat-content">
                    <span class="stat-value">{{ totalParkers }}</span>
                    <span class="stat-label">Total Parkers</span>
                </div>
            </div>
            <div class="stat-card stat-card--active">
                <div class="stat-icon">
                    <i class="fa-solid fa-user-check"></i>
                </div>
                <div class="stat-content">
                    <span class="stat-value">{{ activeParkers }}</span>
                    <span class="stat-label">Active Parkers</span>
                </div>
            </div>
        </div>

        <!-- Search -->
        <div class="search-bar">
            <div class="input-group">
                <span class="input-group-text">
                    <i class="fa-solid fa-search"></i>
                </span>
                <input type="text" class="form-control" placeholder="Search by name, email, phone, parking, or portfolio..." [(ngModel)]="searchTerm" (ngModelChange)="onSearchChange()" />
                <button class="btn btn-outline-secondary" type="button" *ngIf="searchTerm" (click)="searchTerm = ''; onSearchChange()">
                    <i class="fa-solid fa-times"></i>
                </button>
            </div>
        </div>

        <!-- Loading -->
        <div *ngIf="loading" class="text-center py-5">
            <i class="fa-solid fa-spinner fa-spin fa-2x"></i>
            <p class="mt-2">Loading parkers...</p>
        </div>

        <!-- Table -->
        <div class="table-responsive" *ngIf="!loading">
            <table class="table table-hover">
                <thead>
                    <tr>
                        <th (click)="sortBy('firstName')" class="sortable">Name <i class="fa-solid" [ngClass]="getSortIcon('firstName')"></i></th>
                        <th (click)="sortBy('companyName')" class="sortable">Company <i class="fa-solid" [ngClass]="getSortIcon('companyName')"></i></th>
                        <th (click)="sortBy('email')" class="sortable">Email <i class="fa-solid" [ngClass]="getSortIcon('email')"></i></th>
                        <th (click)="sortBy('phoneNumber')" class="sortable">Phone <i class="fa-solid" [ngClass]="getSortIcon('phoneNumber')"></i></th>
                        <th>Current Parking</th>
                        <th>Portfolio</th>
                        <th (click)="sortBy('subscriptionCount')" class="sortable text-center">Total <i class="fa-solid" [ngClass]="getSortIcon('subscriptionCount')"></i></th>
                        <th (click)="sortBy('activeSubscriptionCount')" class="sortable text-center">Active <i class="fa-solid" [ngClass]="getSortIcon('activeSubscriptionCount')"></i></th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let parker of filteredParkers">
                        <td>
                            <strong>{{ parker.firstName }} {{ parker.lastName }}</strong>
                        </td>
                        <td>
                            <span *ngIf="parker.companyName">{{ parker.companyName }}</span>
                            <span class="text-muted" *ngIf="!parker.companyName">-</span>
                        </td>
                        <td>
                            <a [href]="'mailto:' + parker.email" *ngIf="parker.email">{{ parker.email }}</a>
                            <span class="text-muted" *ngIf="!parker.email">-</span>
                        </td>
                        <td>
                            <a [href]="'tel:' + parker.phoneNumber" *ngIf="parker.phoneNumber">{{ parker.phoneNumber }}</a>
                            <span class="text-muted" *ngIf="!parker.phoneNumber">-</span>
                        </td>
                        <td>
                            <ng-container *ngIf="parker.currentParkings.length > 0">
                                <span *ngFor="let parking of parker.currentParkings; let last = last"> {{ parking }}<span *ngIf="!last">, </span> </span>
                            </ng-container>
                            <span class="text-muted" *ngIf="parker.currentParkings.length === 0">No active</span>
                        </td>
                        <td>
                            <ng-container *ngIf="parker.currentPortfolios.length > 0">
                                <span *ngFor="let portfolio of parker.currentPortfolios; let last = last"> {{ portfolio }}<span *ngIf="!last">, </span> </span>
                            </ng-container>
                            <span class="text-muted" *ngIf="parker.currentPortfolios.length === 0">-</span>
                        </td>
                        <td class="text-center">
                            <span class="badge bg-secondary">{{ parker.subscriptionCount }}</span>
                        </td>
                        <td class="text-center">
                            <span class="badge" [ngClass]="parker.activeSubscriptionCount > 0 ? 'bg-success' : 'bg-light text-dark'">
                                {{ parker.activeSubscriptionCount }}
                            </span>
                        </td>
                    </tr>
                    <tr *ngIf="filteredParkers.length === 0 && !loading">
                        <td colspan="8" class="text-center text-muted py-4">
                            <i class="fa-solid fa-user-slash fa-2x mb-2"></i>
                            <p *ngIf="searchTerm">No parkers found matching "{{ searchTerm }}"</p>
                            <p *ngIf="!searchTerm">No parkers found for this enterprise</p>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>

        <!-- Results count -->
        <div class="results-count text-muted" *ngIf="!loading && filteredParkers.length > 0">Showing {{ filteredParkers.length }} of {{ totalParkers }} parkers</div>
    </ng-container>
</div>
